import { updateNotification } from "./utils/updateNotification";
import { events } from "@planzone/events";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";

const reduceDownloadFolderContentNotificationState = createStateReducer(
  initialState,
  {
    [events.downloadFolderContentSucceeded]: (state) => ({
      ...state,
      queue: updateNotification(
        {
          key: "downloadFolderContent",
          flags: ["success"],
          args: { success: "true" },
        },
        state.queue,
      ),
    }),
    [events.downloadFolderContentFailed]: (state) => ({
      ...state,
      queue: updateNotification(
        {
          key: "downloadFolderContent",
          flags: ["failure"],
          args: { failure: "true" },
        },
        state.queue,
      ),
    }),
  },
);

export { reduceDownloadFolderContentNotificationState };
